module.exports = __webpack_public_path__ + "img/data-item2-2.21d704e.png";